import { getTextColor } from 'src/utils/color';

interface Props {
  text: string;
  bgColor: string;
  size?: string;
}

export const ImageBanner = ({ text, bgColor, size = 'lg' }: Props) => {
  if (!text) return null;
  if (text.length > 50) text = text.slice(0, 50) + '...';

  const textColor = getTextColor(bgColor);

  const getAttributes = () => {
    switch (size) {
      case 'sm':
        return {
          top: 85,
          left: -20,
          padding: '2px',
          fontSize: '10px',
          minWidth: '150px',
          fontWeight: 400,
        };
      case 'lg':
      default:
        return {
          top: 140,
          left: -25,
          padding: '5px',
          fontSize: '16px',
          minWidth: '230px',
          fontWeight: 500,
        };
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        backgroundColor: bgColor,
        color: textColor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transform: 'rotate(-45deg)',
        transformOrigin: '0 0',
        whiteSpace: 'nowrap',
        zIndex: 1,
        ...getAttributes(),
      }}
    >
      {text}
    </div>
  );
};

export default ImageBanner;
